import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';

import { Messages } from '../../codegen/Localize';
import { ISiteSettingsForServerAdmin } from '../../settings/types/ISite';
import { deleteSite } from '../actions/SiteMenuActions';

export const DeleteSiteAction: IEntityAction<ISiteSettingsForServerAdmin, {}> = {
  name: EntityActionNames.Delete,
  translateName: Messages.delete_action,
  isVisible: (targetItems: ISiteSettingsForServerAdmin[]) => {
    return targetItems.length > 0;
  },
  isClickable: (_availableActions: {}, targetItems: ISiteSettingsForServerAdmin[]) => {
    return !(targetItems.length === 1 && targetItems[0].settings.urlName === '');
  },
  createReduxAction: (targetItems: ISiteSettingsForServerAdmin[]) => deleteSite(targetItems)
};
